import * as React from 'react';
import { MemoizedFooter } from './footer';
import { NavBar } from './navbar';
import { Box, BoxProps } from '@chakra-ui/react';
import { CookieConsent } from './cookieConsent';
import { MetaPixel } from './metaPixel';
import { focusPointerControl } from '../helpers/pointerFocus';
import { SkipLinks } from './skipLinks';
import { NewsletterPopup, NewsletterProvider } from './newsletter';
import { WhatsAppButton } from './whatsappButton';

export const LocaleContext = React.createContext<{locale: string; catalogLocales?: string[]}>({ locale: 'de-DE' });

type Props = {
  children?: React.ReactNode;
  style: 'light' | 'dark';
  pageContext: {
    locale: string;
    catalogLocales?: string[];
  };
  disableCookieBanner?: boolean;
  hideFooterNewsletter?: boolean;
  hideFloatingWidgets?: boolean;
} & BoxProps;

export const Layout: React.FC<Props> = ({
  children,
  style,
  disableCookieBanner,
  hideFooterNewsletter,
  hideFloatingWidgets = false,
  overflowX = 'hidden',
  pageContext: { locale, catalogLocales },
  ...boxProps
}) => {
  React.useEffect(() => {
    document.addEventListener('click', focusPointerControl, true);
    return () => document.removeEventListener('click', focusPointerControl, true);
  }, []);

  return (
    <LocaleContext.Provider value={{ locale: locale, catalogLocales }}>
      <NewsletterProvider locale={locale}>
        <SkipLinks />
        {!disableCookieBanner && <CookieConsent />}
        <MetaPixel />
        <Box {...boxProps} overflowX={overflowX}>
          <NavBar style={style} id="navigation" />
          <Box id="main-content">
            {children}
          </Box>
          <MemoizedFooter locale={locale} hideNewsletterSignup={hideFooterNewsletter} />
        </Box>
        {!hideFloatingWidgets && <WhatsAppButton />}
        {!hideFloatingWidgets && <NewsletterPopup />}
        <noscript>
          <iframe
            src="https://www.googletagmanager.com/ns.html?id=GTM-MVFHN9XW"
            height="0"
            width="0"
            style={{ display: "none", visibility: "hidden"}}
          ></iframe>
        </noscript>
      </NewsletterProvider>
    </LocaleContext.Provider>
  );
};

Layout.defaultProps = {
  disableCookieBanner: false
};
